var ResetTextStyle = function () {
    this.textStyle.copyFrom(this.defaultTextStyle);
    return this;
};

export default ResetTextStyle;